<!--
  대시보드 종합
  국정원 사이버 위기 경보 위젯

  @since: 2018-06-22
  @author: mk.ko
-->

<template>
  <div ref="chartWrapper"
       class="widget-wrapper">
    <div class="widget-contents">
      <div class="row">
        <gauge-chart
          ref="chartInstanceGauge"
          :options="gaugeOptions"
          :use-only-options="true"
        />
      </div>
      <div v-if="!isConnetFailed" class="widget-contents-option" >
        <q-btn color="primary" size="sm" round class="bs bs-q-btn-sm bs-q-btn-page-title">
          <span class="page-title-1depth-img"></span>
          <q-tooltip anchor="top middle"
                     self="bottom middle"
                     :offset="[10, 10]"
                     class="bs bs-q-tooltip bs-q-tooltip-default">
            <div class="bs-q-tooltip-contents">
              <div>{{ $t('msg.nisCyberAlarm_helper_4') }}</div>
              <div>{{ $t('msg.nisCyberAlarm_helper_5') }}</div>
            </div>
          </q-tooltip>
        </q-btn>
      </div>
      <!-- 추이 차트 -->
      <div class="row">
        <trend-chart ref="chartInstanceTrend"
                     class="widget-contents-chart"
                     :data="widgetData"
                     :x-axis="xAxis"
                     :y-axis="yAxis"
                     :series="series"
                     :tooltip="tooltip"
                     :legend="false"
        />
        <div v-if="isConnetFailed" class="connect-failure">
            <div class="message-wrapper">

              <div class="message-icon">
                <q-icon name="sync_problem" color="orange-6" size="4rem"/>
              </div>

              <div class="message-text text-gray">
                <div>{{ $t('dash.connectFailed').toUpperCase() }}</div>
              </div>

              <div>
                <q-btn color="primary" size="sm" round class="bs bs-q-btn-sm bs-q-btn-page-title">
                  <span class="page-title-1depth-img"></span>
                  <q-tooltip anchor="top middle"
                             self="bottom middle"
                             :offset="[10, 10]"
                             class="bs bs-q-tooltip bs-q-tooltip-default">
                    <div class="bs-q-tooltip-contents">
                      <div>{{ $t('msg.nisCyberAlarm_helper_1') }}</div>
                      <div>{{ $t('msg.nisCyberAlarm_helper_2') }}</div>
                      <div>{{ $t('msg.nisCyberAlarm_helper_3') }}</div>
                    </div>
                  </q-tooltip>
                </q-btn>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Utils
  import {levelColor} from '~/utils/charts'
  // Mixin 객체
  import { widgetMixin } from '~/mixins/widgetCommonMixin'
  // 스토어 헬퍼
  import { createNamespacedHelpers } from 'vuex'
  // // 스토어 헬퍼 객체
  const { mapActions } = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetCyberAlarmInfo',
    directives: {},
    mixins: [ widgetMixin ],
    data () {
      return {
        w: 1,
        title: 'widgetCyberAlarmInfo',
        isLock: false,
        isMove: true,
        isResize: false,
        isMaximum: false,
        eventBus: true,
        // chartType: 'column',
        trendChartData: [],
        opts: {
          isDeviceFilter: false // TAMS
        },
        restData: {
          result: [],
          unit_time: ''
        },
        isConnetFailed: false,
        // Chart Data
        levelInfo: {},
        widgetData: [],
        // Chart Options
        grade: [
          [0.2, levelColor[0]],
          [0.4, levelColor[1]],
          [0.6, levelColor[2]],
          [0.8, levelColor[3]],
          [1.0, levelColor[4]]
        ],
        xAxisRawData: {
          type: 'time',
          data: [],
          axisLine: { onZero: true },
          axisLabel: {
            formatter: '{HH}:{mm}:{ss}  ',
            hideOverlap: true
          }
        },
        yAxisRawData: {
          type: 'value',
          position: 'left',
          interval: 5,
          max: 5
        }
      }
    },
    props: {},
    computed: {
      // treund chart
      series () {
        return [ { id: 'gradeTrend', type: 'line', name: this.$t('dash.level'), smooth: 0.6, lineStyle: {width: 1}, symbol: 'circle', showSymbol: false, triggerLineEvent: true } ]
      },
      xAxis: {
        get () { return this.xAxisRawData },
        set (options) { this.xAxisRawData = options }
      },
      yAxis: {
        get () { return this.yAxisRawData },
        set (options) { this.yAxisRawData = options }
      },
      tooltip () {
        return {
          axisPointer: {type: 'line'},
          formatter: (params) => {
            let resFormat = `<b>${params[0].axisValueLabel.split(' ')[1]}</b><br>`
            for (let i = 0, max = params.length; i < max; i++) {
              const cnt = Math.abs(params[i].value[1])
              resFormat += `${params[i].marker}${params[i].seriesName} : <b>${this.kmgtConverter(cnt)}${this.restData.unit_time}</b><br>`
            }
            return resFormat
          }
        }
      },
      // gauge chart
      gaugeOptions () {
        return {
          series: [
            {
              type: 'gauge',
              grid: {
                top: '0%',
                left: '0%',
                right: '0%',
                bottom: '0%'
              },
              min: 0,
              max: 1,
              center: ['50%', '60%'],
              radius: '95%',
              endAngle: -40,
              startAngle: 220,
              title: {
                show: false
              },
              detail: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  width: 3,
                  color: this.grade
                }
              },
              axisLabel: {
                show: false
              }
            },
            {
              type: 'gauge',
              min: 0,
              max: 1,
              data: [
                {
                  name: this.isConnetFailed ? '' : this.$t('dash.level'),
                  value: this.levelInfo.ratio
                }
              ],
              color: this.levelInfo.color,
              title: {
                offsetCenter: ['0%', '-40%'],
                fontWeight: 'bold',
                fontSize: '20px'
              },
              center: ['50%', '60%'],
              detail: {
                color: this.levelInfo.color,
                formatter: this.setComplexFormatter,
                offsetCenter: ['0%', '12%'],
                fontSize: '32px'
              },
              radius: '120%',
              pointer: {
                show: false
              },
              endAngle: -40,
              startAngle: 220,
              progress: {
                show: true,
                width: 5,
                overlap: false,
                roundCap: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              }
            }
          ]
        }
      }
    },
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      refreshChartData () {
        this.getWidgetContentsData(true)
      },
      getRatioLevel (level) {
        let res = ''
        switch (level) {
          case 1:
            res = { level: 1, ratio: 0.2, label: this.$t('dash.normal').toUpperCase(), color: levelColor[0] }
            break
          case 2:
            res = { level: 2, ratio: 0.4, label: this.$t('dash.attention').toUpperCase(), color: levelColor[1] }
            break
          case 3:
            res = { level: 3, ratio: 0.6, label: this.$t('dash.caution').toUpperCase(), color: levelColor[2] }
            break
          case 4:
            res = { level: 4, ratio: 0.8, label: this.$t('dash.warning').toUpperCase(), color: levelColor[3] }
            break
          case 5:
            res = { level: 5, ratio: 1, label: this.$t('dash.critical').toUpperCase(), color: levelColor[4] }
            break
          default:
            res = { level: 0, ratio: 0, label: this.$t('dash.connectFailed').toUpperCase(), color: '#9b9b9b' }
        }
        return res
      },
      async getWidgetContentsData (init = false) {
        // Progress 출력 여부
        this.showProgress(true)
        this.isConnetFailed = false

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 데이터 초기화
          this.widgetData = []

          // 차트 씨리즈 초기화
          this.$refs.chartInstanceGauge.clear()
          this.$refs.chartInstanceTrend.clear()
        }

        // 0. API 호출
        let resNcsc = await this.getWidgetData({
          widgetType: 'ncsc_alert'
        })

        let resNcscTrend = await this.getWidgetData({
          widgetType: 'ncsc_alert_trend'
        })

        let level = []

        if (resNcsc.code === 'ok') {
          // = TEST DATA
          // resNcsc = {
          //   code: 'ok',
          //   result: {
          //     unit_time: '6h',
          //     result: [
          //       { alert_level: 4 }
          //     ]
          //   }
          // }
          try {
            const receiveLevel = resNcsc.result.result[0].alert_level || 0
            // this.levelInfo = this.getRatioLevel(receiveLevel * 20)
            this.levelInfo = this.getRatioLevel(receiveLevel)
            level = this.levelInfo.level
          } catch (e) {
            level = 0
          }
        } else {
          level = 0
        }

        // 연결 실패
        if (level === 0) {
          this.isConnetFailed = true
          this.levelInfo = {}
        }
        // this.isConnetFailed = false

        // = TEST DATA
        // resNcscTrend = {
        //   code: 'ok',
        //   result: {
        //     unit_time: '/10min',
        //     result: [
        //       { time: '2023-12-28 16:10:00', alert_level: 0 },
        //       { time: '2023-12-28 16:20:00', alert_level: 3 },
        //       { time: '2023-12-28 16:30:00', alert_level: 4 },
        //       { time: '2023-12-28 16:40:00', alert_level: 5 },
        //       { time: '2023-12-28 16:50:00', alert_level: 4 },
        //       { time: '2023-12-28 17:00:00', alert_level: 3 },
        //       { time: '2023-12-28 17:10:00', alert_level: 2 },
        //       { time: '2023-12-28 17:20:00', alert_level: 1 }
        //     ]
        //   }
        // }

        if (resNcscTrend.code === 'ok' && _.get(resNcscTrend, ['result', 'result', 'length'], 0) > 0) {
          this.restData = resNcscTrend.result
          this.widgetData = [[]]
          for (const ncscTrend of this.restData.result) {
            const receiveLevel = ncscTrend.alert_level || 0
            const time = ncscTrend.time

            this.widgetData[0].push([time, receiveLevel])
          }
        } else {
          // TAMS - All update 기준
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstanceGauge.clear()
          this.$refs.chartInstanceTrend.clear()
        }
        // Progress 출력 여부
        this.showProgress(false)
      },
      onResizeContentsFromWidget () {
        // 차트 래퍼 컨테이너 객체
        const chartWrapper = this.$refs.chartWrapper

        // 차트 래퍼가 있으면 다음단계 진행
        if (chartWrapper) {
          // Gauge 차트 인스턴스 가져오기
          const chartInstance = _.has(this.$refs.chartInstanceGauge, 'getChartInstance') ? this.$refs.chartInstanceGauge.getChartInstance() : this.$refs.chartInstanceGauge

          // Trend 차트 인스턴스 가져오기
          const trendInstance = _.has(this.$refs.chartInstanceTrend, 'getChartInstance') ? this.$refs.chartInstanceTrend.getChartInstance() : this.$refs.chartInstanceTrend

          // Tooltip DOM 가져오기
          if (trendInstance.tooltip) {
            const tooltipDom = trendInstance.tooltip.container

            // Tooltip DOM 위치 초기화
            if (tooltipDom) {
              tooltipDom.style.left = 0
            }
          }

          // 래퍼 크기 구하기
          let
            wrapperWidth = chartWrapper.clientWidth,
            wrapperHeight = chartWrapper.clientHeight < 249 ? 249 : chartWrapper.clientHeight || 249

          if (chartWrapper.className.indexOf('pad0') < 0) {
            wrapperWidth -= 24
            wrapperHeight -= 24
          }

          // 인스턴스 사이즈 조절
          chartInstance.setSize(wrapperWidth, (wrapperHeight / 2) + 8, false)
          trendInstance.setSize(wrapperWidth, (wrapperHeight / 2), false)
          // trendInstance.setSize(wrapperWidth - 12, wrapperHeight / 2, false)
        }
      },
      setComplexFormatter (ratio) {
        const dictLevel = {
          0: '',
          0.2: this.$t('dash.normal').toUpperCase(), // 정상
          0.4: this.$t('dash.attention').toUpperCase(), // 관심
          0.6: this.$t('dash.caution').toUpperCase(), // 주의
          0.8: this.$t('dash.warning').toUpperCase(), // 경계
          1: this.$t('dash.critical').toUpperCase() // 심각
        }
        return _.get(dictLevel, ratio, '')
      }
    }
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-option {
    z-index: 10;
    right: 0;
    display: flex;
    position: absolute;
    padding-top: 5px;
    padding-right: 17px;
    margin-bottom: 5px;
    bottom: 110px;
  }

  .widget-contents {
    /*flex-grow: 1;*/
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /*.widget-contents-wrapper {*/
  /*  flex-grow: 1;*/
  /*  display: flex;*/
  /*}*/

  .widget-contents-chart {
    flex-grow: 1;
  }

  .connect-failure {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(230, 230, 230, 0.8);
    /* ie */
    top: 0px;
    left: 0px;
  }

  .connect-success {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: right;

    position: absolute;
    width: 100%;
    height: 100%;
    /*background-color: rgba(230, 230, 230, 0.8);*/
    /* ie */
    top: 0px;
    left: 0px;
  }

  /*.alert-level {*/
  /*  flex-grow: 1;*/
  /*  display: flex;*/
  /*  !*flex-direction: row;*!*/
  /*  !*align-items: center;*!*/
  /*  !*justify-content: center;*!*/

  /*  !*position: absolute;*!*/
  /*  !*width: 100%;*!*/
  /*  !*height: 100%;*!*/
  /*  !* ie *!*/
  /*  !*top: 0px;*!*/
  /*  !*left: 0px;*!*/
  /*}*/

  .message-wrapper {
    text-align: center;
    /*vertical-align: middle;*/
  }

  .connect-success .message-wrapper {
    position: absolute;
    top: 39px
  }
  .message-info {
    float: right;
    margin-top: -20px;
  }
  .message-wrapper .message-levelTitle span {
    font-size: 20px;
    font-weight: 600;
    text-shadow: 0 0 4px #fff; /* horizontal-offset vertical-offset 'blur' colour */
    -moz-text-shadow: 0 0 4px #fff;
    -webkit-text-shadow: 0 0 4px #fff;
  }

  .message-wrapper .message-levelText {
    margin-top: 5px;
  }
  .message-levelText span {
    line-height: 35px;
    font-size: 35px;
    font-weight: 700;
    text-shadow: 0 0 4px #fff; /* horizontal-offset vertical-offset 'blur' colour */
    -moz-text-shadow: 0 0 4px #fff;
    -webkit-text-shadow: 0 0 4px #fff;
  }

  .message-wrapper .message-text {
    font-size: 2em;
    font-weight: 700;
  }

  .text-gray {
    color: gray;
  }

</style>
